import { useContext, useEffect, useRef, useState } from "react";
import "./SHSidebar.css";
import {
  TbPlus,
  TbSettings,
  TbMail,
  TbMessagePlus,
  TbMessageOff,
  TbCheck,
  TbChevronRight,
  TbChevronDown,
} from "react-icons/tb";
import { useLanguage } from "../../../../LanguageProvider";
import AddChatRoomModal from "../AddChatRoomModal/AddChatRoomModal";
import AddChannelModal from "../AddChannelModal/AddChannelModal";
import { LuMessageSquarePlus } from "react-icons/lu";
import { GeneralContext } from "../../../../GeneralProvider";
import { IoCompassOutline } from "react-icons/io5";
import InputField from "../../../../components/InputField/InputField";
import Services from "../../../../services/Services";
import io from "socket.io-client";
import AddRoomGroupModal from "../AddRoomGroupModal/AddRoomGroupModal";
import { RxCross2 } from "react-icons/rx";
import AlertBox from "../../../../components/AlertBox/AlertBox";
import SettingsSidebar from "./SettingsSidebar";

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;

export default function SHSidebar({
  channels,
  categories,
  onSettingsClick,
  onRoomClick,
  activeChannel,
  setActiveChannel,
  activeRoom,
  setActiveRoom,
  getChannelRooms,
  onDiscoverClick,
  setSelectedSearchChannel,
  setIsSearchedChannelJoined,
  selectedSearchChannel,
  dmRefreshFlag,
  roomsWithUnreadMessage,
  setRoomsWithUnread,
  activeView,
  orderedRooms = [],
  setOrderedRooms,
  getMyChannels,
  isSettings = false,
  activeSettingsMenu,
  setActiveSettingsMenu
}) {
  const {
    handleLeaveRoom,
    handleJoinRoom,
    myChannels,
    userId,
    shChannelUri,
    subscriptionType,
  } = useContext(GeneralContext);
  const socketRef = useRef();
  const { getTranslation } = useLanguage();
  const [isAddRoomModalOpen, setIsAddRoomModalOpen] = useState(false);
  const [isAddChannelModalOpen, setIsAddChannelModalOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [isAdmin, setIsAdmin] = useState();

  const [dmSearchInputValue, setDmSearchInputValue] = useState("");
  const [dmSearchResult, setDmSearchResult] = useState([]);

  const [myDmList, setMyDmList] = useState([]);
  const [draggedRoom, setDraggedRoom] = useState(null);

  const [isAddGroupModalOpen, setIsAddGroupModalOpen] = useState(false);
  const [roomGroups, setRoomGroups] = useState([]);

  const [draggedRoomID, setDraggedRoomID] = useState(null);
  const [sourceGroupID, setSourceGroupID] = useState(null);
  const [draggedGroupID, setDraggedGroupID] = useState(null);
  const [targetGroupForNewRoom, setTargetGroupForNewRoom] = useState(null);
  const [expandedGroupIDs, setExpandedGroupIDs] = useState([]);
  const [isUngroupedOpen, setIsUngroupedOpen] = useState(true);
  const [isDeleteDMOpen, setIsDeleteDMOpen] = useState(false);
  const [dmToDelete, setDmToDelete] = useState(null);

  const handleGroupDrop = (targetGroupID) => {
    if (!draggedGroupID || draggedGroupID === targetGroupID) return;

    const oldGroups = [...roomGroups];
    const fromIndex = oldGroups.findIndex((g) => g.groupID === draggedGroupID);
    const toIndex = oldGroups.findIndex((g) => g.groupID === targetGroupID);

    if (fromIndex === -1 || toIndex === -1) return;

    const movedGroup = oldGroups.splice(fromIndex, 1)[0];
    oldGroups.splice(toIndex, 0, movedGroup);

    setRoomGroups(oldGroups);
    updateSettings(oldGroups); // backend'e yaz

    setDraggedGroupID(null);
  };

  useEffect(() => {
    const groups = activeChannel?.settings?.roomGroups;
    if (Array.isArray(groups)) {
      setRoomGroups(groups);
      setExpandedGroupIDs(groups.map((g) => g.groupID)); // Hepsini aç
    } else if (Array.isArray(groups?.roomGroups)) {
      setRoomGroups(groups.roomGroups);
      setExpandedGroupIDs(groups.roomGroups.map((g) => g.groupID));
    } else {
      setRoomGroups([]);
      setExpandedGroupIDs([]);
    }
  }, [activeChannel]);

  useEffect(() => {
    const groups = activeChannel?.settings?.roomGroups;
    if (Array.isArray(groups)) {
      setRoomGroups(groups);
    } else if (Array.isArray(groups?.roomGroups)) {
      setRoomGroups(groups.roomGroups);
    } else {
      setRoomGroups([]);
    }
  }, [activeChannel]);

  const handleDrop = (targetRoomID) => {
    const currentIndex = orderedRooms.findIndex(
      (room) => room.roomID === draggedRoom
    );
    const targetIndex = orderedRooms.findIndex(
      (room) => room.roomID === targetRoomID
    );

    if (currentIndex === -1 || targetIndex === -1) return;

    const newOrder = [...orderedRooms];
    const [movedItem] = newOrder.splice(currentIndex, 1);
    newOrder.splice(targetIndex, 0, movedItem);

    setOrderedRooms(newOrder);

    // Ayarları kanala yaz (örnek)
    const newSettings = {
      ...(activeChannel.settings || {}),
      roomOrder: newOrder.map((r) => r.roomID),
    };

    // ➕ Güncel settings backend'e gönder
    const token = localStorage.getItem("token");
    Services.SocialHiveUpdateChannelSettings(
      token,
      activeChannel.channelID,
      newSettings
    ).then((res) => {
      getMyChannels();
    });
  };

  const onLeaveRoom = (roomID) => {
    handleLeaveRoom(activeChannel.channelID, roomID);
  };

  const onjoinRoom = (roomID) => {
    handleJoinRoom(activeChannel.channelID, roomID);
  };

  useEffect(() => {
    setInputValue("");
    setSelectedSearchChannel("");
  }, [activeView]);

  useEffect(() => {
    if (
      myChannels.length > 0 &&
      activeChannel.channelID !== "0" &&
      activeChannel.channelID !== "discover"
    ) {
      if (myChannels.find((x) => x.channelID === activeChannel.channelID)) {
        setIsAdmin(
          myChannels.find((x) => x.channelID === activeChannel.channelID)
            .isAdmin
        );
      } else {
        setIsAdmin("0");
      }
    }
  }, [activeChannel, myChannels]);

  useEffect(() => {
    const handler = setTimeout(() => {
      onSearch();
    }, 500);

    return () => clearTimeout(handler);
  }, [inputValue]);

  const onSearch = () => {
    const token = localStorage.getItem("token");
    Services.SocialHiveChannelSearch(token, inputValue)
      .then((res) => {
        if (res.data.status) {
          setSearchResult(res.data.result);
        } else {
          setSearchResult([]);
        }
      })
      .catch(() => setSearchResult([]));
  };

  const onSearchUri = () => {
    const token = localStorage.getItem("token");
    Services.SocialHiveChannelSearch(token, shChannelUri)
      .then((res) => {
        if (res.data.status) {
          const isJoined = myChannels.some(
            (c) => c.channelID === res.data.result[0].channelID
          );
          setSelectedSearchChannel(res.data.result[0]);
          setIsSearchedChannelJoined(isJoined);
        } else {
          setSearchResult([]);
        }
      })
      .catch(() => setSearchResult([]));
  };

  useEffect(() => {
    if (shChannelUri) {
      onSearchUri();
    }
  }, []);

  useEffect(() => {
    if (!dmSearchInputValue.trim()) {
      setDmSearchResult([]);
      return;
    }

    const dmhandler = setTimeout(() => {
      onDMUserSearch();
    }, 400);

    return () => clearTimeout(dmhandler);
  }, [dmSearchInputValue]);

  const onDMUserSearch = () => {
    const token = localStorage.getItem("token");
    const q = dmSearchInputValue?.trim();

    if (!q || q.replace(/\s+/g, "").length < 2) {
      setDmSearchResult([]);
      return;
    }

    const terms = q.toLowerCase().split(/\s+/).filter(Boolean);

    Services.SocialHiveDMUserSearch(token, terms[0])
      .then((res) => {
        const raw = res.data.status ? res.data.result : [];
        const candidates = raw.filter(
          (user) => String(user.id) !== String(userId)
        );

        const filtered = candidates.filter((u) => {
          const full = `${u.name ?? ""} ${u.lastname ?? ""}`.toLowerCase();
          return terms.every((term) => full && full.includes(term));
        });

        setDmSearchResult(filtered);
      })
      .catch(() => setDmSearchResult([]));
  };

  const getMyDMList = () => {
    const token = localStorage.getItem("token");
    Services.SocialHiveGetDMRoomList(token)
      .then((res) => {
        if (res.data.status) {
          setMyDmList(res.data.result);
          const unreadRoomIDs = res.data.result
            .filter((chat) => chat.hasUnreadMessage === true)
            .map((chat) => chat.roomID);
          setRoomsWithUnread(unreadRoomIDs);
          setDmSearchResult([]);
        } else {
          setDmSearchResult([]);
          setMyDmList([]);
        }
      })
      .catch((err) => {
        setMyDmList([]);
        console.log(err);
      });
  };

  useEffect(() => {
    if (activeChannel.channelID === "0") {
      getMyDMList();
    }
  }, [activeChannel.channelID, dmRefreshFlag]);

  useEffect(() => {
    socketRef.current = io(SOCKET_URL);

    return () => {
      socketRef.current.disconnect();
    };
  }, []);

  const createDM = (userID) => {
    const token = localStorage.getItem("token");

    const existingDM = myDmList.find(
      (dm) => dm.ownerID === userID || dm.receiverID === userID
    );
    if (existingDM) {
      setActiveRoom(existingDM);
      getMyDMList();
      setDmSearchInputValue("");
    } else {
      // Yoksa yeni DM oluştur
      Services.SocialHiveCreateDM(token, userID)
        .then((res) => {
          if (res.data.status) {
            setActiveRoom(res.data.result);
            getMyDMList();
            setDmSearchInputValue("");
          }
        })
        .catch((err) => console.error(err));
    }
  };

  function getFirstAndLastInitials(sentence) {
    const words = sentence
      .trim()
      .split(/\s+/)
      .filter((w) => w.length > 0);
    if (words.length === 0) return "";
    const firstInitial = words[0][0];
    const lastInitial = words[words.length - 1][0];
    return (firstInitial + lastInitial).toUpperCase();
  }

  function getAvatarColor(userName) {
    if (!userName) return 'var(--avatar-color-1)';
    const initials = getFirstAndLastInitials(userName);
    if (!initials) return 'var(--avatar-color-1)';
    // Use a simple hash to consistently map to one of 4 colors
    const hash = initials.charCodeAt(0) + (initials.length > 1 ? initials.charCodeAt(1) : 0);
    const colorIndex = (hash % 4) + 1;
    return `var(--avatar-color-${colorIndex})`;
  }

  const handleRoomDrop = (targetRoomID, targetGroupID) => {
    if (!draggedRoomID || isAdmin !== "1") return;

    // Aynı odaysa işlem yapma
    if (draggedRoomID === targetRoomID && sourceGroupID === targetGroupID)
      return;

    const isSameGroup = sourceGroupID === targetGroupID;

    // Aynı grup içindeki sıralama (oda boş alana bırakıldıysa sona eklenir)
    if (isSameGroup && sourceGroupID !== null && targetRoomID === null) {
      const targetGroup = roomGroups.find((g) => g.groupID === sourceGroupID);
      if (!targetGroup) return;

      const newOrder = [...targetGroup.roomOrder];
      const fromIdx = newOrder.indexOf(draggedRoomID);

      if (fromIdx === -1) return;

      newOrder.splice(fromIdx, 1);
      newOrder.push(draggedRoomID); // sona ekle

      const updatedGroups = roomGroups.map((g) =>
        g.groupID === sourceGroupID ? { ...g, roomOrder: newOrder } : g
      );

      setRoomGroups(updatedGroups);
      updateSettings(updatedGroups);
      return;
    }

    // Eğer grup içinde sıralama yapılıyorsa
    if (isSameGroup && sourceGroupID !== null) {
      const targetGroup = roomGroups.find((g) => g.groupID === sourceGroupID);
      if (!targetGroup) return;

      const newOrder = [...targetGroup.roomOrder];
      const fromIdx = newOrder.indexOf(draggedRoomID);
      const toIdx = newOrder.indexOf(targetRoomID);

      if (fromIdx === -1 || toIdx === -1) return;

      newOrder.splice(fromIdx, 1);
      newOrder.splice(toIdx, 0, draggedRoomID);

      const updatedGroups = roomGroups.map((g) =>
        g.groupID === sourceGroupID ? { ...g, roomOrder: newOrder } : g
      );

      setRoomGroups(updatedGroups);
      updateSettings(updatedGroups);
      return;
    }

    // Grup değiştirme veya gruptan-grupsuza ya da tersi
    let updatedGroups = [...roomGroups];

    // Eski gruptan çıkar
    if (sourceGroupID) {
      updatedGroups = updatedGroups.map((g) =>
        g.groupID === sourceGroupID
          ? {
            ...g,
            roomOrder: g.roomOrder.filter((id) => id !== draggedRoomID),
          }
          : g
      );
    }

    // Hedef gruba ekle
    if (targetGroupID) {
      updatedGroups = updatedGroups.map((g) =>
        g.groupID === targetGroupID
          ? (() => {
            const roomOrder = [...g.roomOrder];
            const insertIndex = roomOrder.indexOf(targetRoomID);
            if (insertIndex === -1)
              return { ...g, roomOrder: [...roomOrder, draggedRoomID] };

            roomOrder.splice(insertIndex, 0, draggedRoomID);
            return { ...g, roomOrder };
          })()
          : g
      );
    }

    setRoomGroups(updatedGroups);
    updateSettings(updatedGroups);
  };

  const updateSettings = (newRoomGroups) => {
    const token = localStorage.getItem("token");
    Services.SocialHiveUpdateChannelSettings(token, activeChannel.channelID, {
      roomGroups: newRoomGroups,
    }).then(() => {
      getMyChannels();
    });

    setDraggedRoomID(null);
    setSourceGroupID(null);
  };

  return (
    <div className="sh-sidebar">
      {/* Kanal Listesi */}
      <div className="sh-server-panel">
        <ul className="sh-servers">
          <li
            key="default-server"
            className={`sh-server${activeChannel.channelID === "0" ? " sh-server--active" : ""
              }`}
            style={{ position: "relative" }}
            onClick={() => {
              setActiveChannel({
                channelID: "0",
                title: getTranslation("directMessages"),
              });
              setActiveRoom("");
            }}
            title={getTranslation("directMessages")}
          >
            {roomsWithUnreadMessage.length > 0 &&
              activeChannel.channelID !== "0" && (
                <span
                  className="light-dot"
                  style={{
                    background: "rgba(229, 147, 42, 1)",
                    height: "7px",
                    width: "7px",
                    borderRadius: "50px",
                    position: "absolute",
                    top: -2,
                    right: -2,
                  }}
                />
              )}
            <TbMail size={20} />
          </li>

          <li
            key="default-server"
            className={`sh-server${activeChannel.channelID === "discover" ? " sh-server--active" : ""
              }`}
            onClick={() => {
              setActiveChannel({
                channelID: "discover",
                title: getTranslation("discover"),
              });
              onDiscoverClick();
              setActiveRoom("");
            }}
            title={getTranslation("discover")}
          >
            <IoCompassOutline size={20} />
          </li>
          {channels.map((chn) => {
            const id = chn.channelID;
            const title = chn.title;
            const hasLogo = chn.logo && chn.logo.length > 2;
            return (
              <li
                key={id}
                className={`sh-server${activeChannel.channelID === id ? " sh-server--active" : ""
                  }`}
                onClick={() => {
                  setActiveChannel(chn);
                  getChannelRooms(id);
                  setActiveRoom("");
                }}
                title={title}
              >
                {hasLogo ? (
                  <img src={chn.logo} alt={title} className="sh-server-logo" />
                ) : (
                  <span className="sh-server-initial">
                    {title.charAt(0).toUpperCase()}
                  </span>
                )}
              </li>
            );
          })}
        </ul>

        {subscriptionType === "professional" ? (
          <button
            title={getTranslation("createChannel")}
            onClick={() => setIsAddChannelModalOpen(true)}
            className="sh-server-add-btn"
          >
            <TbPlus strokeWidth={3} size={24} />
          </button>
        ) : (
          <button
            disabled
            title={getTranslation("upgradeToProfessional")}
            onClick={() => setIsAddChannelModalOpen(true)}
            className="sh-server-add-btn"
          >
            <TbPlus strokeWidth={3} size={24} />
          </button>
        )}
      </div>

      {/* Oda Listesi */}
      {!isSettings ?
        <div className="sh-channels-panel">
          <span className="sh-channels-title-holder">
            <span>{activeChannel.title}</span>
          </span>

          {activeChannel.channelID !== "discover" &&
            activeChannel.channelID !== "0" && (
              <>
                {isAdmin === "1" && (
                  <button
                    title={getTranslation("createGroup")}
                    onClick={() => setIsAddGroupModalOpen(true)}
                    className="sh-main-category-add-btn"
                  >
                    <TbPlus strokeWidth={3} size={16} />{" "}
                    {getTranslation("addGroup")}
                  </button>
                )}
                {categories.map((cat, i) => (
                  <div key={i} className="sh-category">
                    {activeChannel.channelID !== "0" &&
                      activeChannel.channelID !== "discover" && (
                        <div
                          onDragOver={(e) => e.preventDefault()}
                          onDrop={() => {
                            if (!draggedRoomID) return;
                            handleRoomDrop(null, null);
                          }}
                          onClick={() => setIsUngroupedOpen((prev) => !prev)}
                          className="sh-category-header"
                          style={{ cursor: "var(--pointer)" }}
                        >
                          <span className="sh-category-title">
                            {isUngroupedOpen ? (
                              <TbChevronDown />
                            ) : (
                              <TbChevronRight />
                            )}{" "}
                            {cat.name}
                          </span>

                          {isAdmin === "1" && (
                            <button
                              onClick={(e) => {
                                e.stopPropagation(); // toggle'ı engeller
                                setIsAddRoomModalOpen(true);
                              }}
                              className="sh-category-add-btn"
                            >
                              <TbPlus strokeWidth={3} size={16} />
                            </button>
                          )}
                        </div>
                      )}
                    {/* Kanaldaki Odalar */}
                    {(() => {
                      const groupedRoomIDs = Array.isArray(roomGroups)
                        ? roomGroups.flatMap((g) => g.roomOrder)
                        : [];
                      const ungroupedRooms = orderedRooms.filter(
                        (r) => !groupedRoomIDs.includes(r.roomID)
                      );
                      if (ungroupedRooms.length === 0) return null;
                      return (
                        <div
                          className="sh-category"
                          onDragOver={(e) => e.preventDefault()}
                          onDrop={() => {
                            if (!draggedRoomID) return;
                            handleRoomDrop(null, null);
                          }}
                        >
                          {isUngroupedOpen && (
                            <ul className="sh-channels-list">
                              {ungroupedRooms.map((room) => (
                                <div
                                  style={{
                                    flexDirection: "row",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px",
                                    justifyContent: "center",
                                  }}
                                >
                                  <li
                                    data-roomid={room.roomID}
                                    key={room.roomID}
                                    draggable
                                    onDrop={(e) =>
                                      handleRoomDrop(
                                        e.currentTarget.dataset.roomid,
                                        null
                                      )
                                    }
                                    onDragStart={() => {
                                      setDraggedRoomID(room.roomID);
                                      setSourceGroupID(null);
                                    }}
                                    onDragOver={(e) => e.preventDefault()}
                                    className={`sh-channel${activeRoom.roomID === room.roomID && (activeView === "chat" || !activeView)
                                      ? " sh-channel--active"
                                      : ""
                                      }`}
                                    onClick={() => {
                                      setActiveRoom(room);
                                      onRoomClick();
                                      onjoinRoom(room.roomID);
                                    }}
                                    title={room.title}
                                  >
                                    #{room.title}
                                  </li>
                                  {/* {room.isUserJoinned === true ?
                              <TbMessageOff title={getTranslation("leave")} onClick={() => { onLeaveRoom(room.roomID); if (activeRoom.roomID === room.roomID) { setActiveRoom(""); } }} style={{ color: "var(--sh-channel-font-color)", cursor: 'var(--pointer)' }} size={15} />
                              :
                              <TbMessagePlus title={getTranslation("join")} onClick={() => onjoinRoom(room.roomID)} style={{ color: "var(--sh-channel-font-color)", cursor: 'var(--pointer)' }} size={15} />
                            } */}
                                </div>
                              ))}
                            </ul>
                          )}
                        </div>
                      );
                    })()}
                    {Array.isArray(roomGroups) && (
                      <ul className="sh-channels-list">
                        {roomGroups?.map((group, index) => {
                          const groupRooms = orderedRooms
                            .filter((room) =>
                              group.roomOrder.includes(room.roomID)
                            )
                            .sort(
                              (a, b) =>
                                group.roomOrder.indexOf(a.roomID) -
                                group.roomOrder.indexOf(b.roomID)
                            );

                          const groupedRoomIDs = Array.isArray(roomGroups)
                            ? roomGroups.flatMap((g) => g.roomOrder)
                            : [];

                          const ungroupedRooms = orderedRooms.filter(
                            (r) => !groupedRoomIDs.includes(r.roomID)
                          );

                          return (
                            <div
                              key={group.groupID}
                              className="sh-category"
                              onDragOver={(e) => e.preventDefault()}
                              onDrop={() => {
                                if (!draggedRoomID) return;
                                handleRoomDrop(null, group.groupID); // oda direkt gruba bırakıldı
                              }}
                              style={{
                                marginTop:
                                  index === 0 && ungroupedRooms.length === 0
                                    ? "16px"
                                    : 0,
                              }}
                            >
                              <div
                                className="sh-category-header"
                                draggable
                                onDragStart={() =>
                                  setDraggedGroupID(group.groupID)
                                }
                                onDragOver={(e) => e.preventDefault()}
                                onDrop={() => handleGroupDrop(group.groupID)}
                                onClick={() => {
                                  setExpandedGroupIDs((prev) => {
                                    if (prev.includes(group.groupID)) {
                                      return prev.filter(
                                        (id) => id !== group.groupID
                                      ); // kapat
                                    } else {
                                      return [...prev, group.groupID]; // aç
                                    }
                                  });
                                }}
                                style={{ cursor: "var(--pointer)" }}
                              >
                                <span className="sh-category-title">
                                  {expandedGroupIDs.includes(group.groupID) ? (
                                    <TbChevronDown />
                                  ) : (
                                    <TbChevronRight />
                                  )}{" "}
                                  {group.title}
                                </span>
                                {isAdmin === "1" && (
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation(); // toggle'ı engeller
                                      setTargetGroupForNewRoom(group.groupID); // hedef grup setlenir
                                      setIsAddRoomModalOpen(true);
                                    }}
                                    className="sh-category-add-btn"
                                  >
                                    <TbPlus strokeWidth={3} size={16} />
                                  </button>
                                )}
                              </div>
                              {expandedGroupIDs.includes(group.groupID) && (
                                <ul className="sh-channels-list">
                                  {groupRooms.map((room) => (
                                    <div
                                      style={{
                                        flexDirection: "row",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "5px",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <li
                                        data-roomid={room.roomID}
                                        key={room.roomID}
                                        draggable
                                        onDrop={(e) =>
                                          handleRoomDrop(
                                            e.currentTarget.dataset.roomid,
                                            group.groupID
                                          )
                                        }
                                        onDragStart={() => {
                                          setDraggedRoomID(room.roomID);
                                          setSourceGroupID(group.groupID);
                                        }}
                                        onDragOver={(e) => e.preventDefault()}
                                        className={`sh-channel${activeRoom.roomID === room.roomID && (activeView === "chat" || !activeView)
                                          ? " sh-channel--active"
                                          : ""
                                          }`}
                                        onClick={() => {
                                          setActiveRoom(room);
                                          onRoomClick();
                                          onjoinRoom(room.roomID);
                                        }}
                                        title={room.title}
                                      >
                                        #{room.title}
                                      </li>
                                      {/* {room.isUserJoinned === true ?
                                    <TbMessageOff title={getTranslation("leave")} onClick={() => { onLeaveRoom(room.roomID); if (activeRoom.roomID === room.roomID) { setActiveRoom(""); } }} style={{ color: "var(--sh-channel-font-color)", cursor: 'var(--pointer)' }} size={15} />
                                    :
                                    <TbMessagePlus title={getTranslation("join")} onClick={() => onjoinRoom(room.roomID)} style={{ color: "var(--sh-channel-font-color)", cursor: 'var(--pointer)' }} size={15} />
                                  } */}
                                    </div>
                                  ))}
                                </ul>
                              )}
                            </div>
                          );
                        })}
                      </ul>
                    )}
                  </div>
                ))}
              </>
            )}

          {/* Discover Channel Kısmı */}
          {activeChannel.channelID === "discover" && (
            <div
              style={{
                width: "100%",
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <InputField
                placeholder={getTranslation("search")}
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                style={{
                  height: "38px",
                  width: "150px",
                  paddingLeft: "5px",
                  boxSizing: "border-box",
                }}
              />
              <ul className="sh-channels-list" style={{ gap: "10px" }}>
                {searchResult.map((ch) => {
                  const isJoined = myChannels.some(
                    (c) => c.channelID === ch.channelID
                  );
                  return (
                    <div
                      key={ch.channelID}
                      onClick={() => {
                        setSelectedSearchChannel(ch);
                        setIsSearchedChannelJoined(isJoined);
                      }}
                      className={`sh-search-channel${selectedSearchChannel.channelID === ch.channelID
                        ? " sh-search-channel--active"
                        : ""
                        }`}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "160px",
                        gap: "8px",
                        padding: "4px 8px",
                        boxSizing: "border-box",
                        cursor: "var(--pointer)",
                      }}
                      title={ch.title}
                    >
                      {ch.logo ? (
                        <img
                          src={ch.logo}
                          alt={ch.title}
                          width={25}
                          height={25}
                          style={{ borderRadius: "50%" }}
                        />
                      ) : (
                        <div
                          style={{
                            minWidth: "25px",
                            minHeight: "25px",
                            borderRadius: "50%",
                            backgroundColor: "#ccc",
                          }}
                        />
                      )}
                      <span className="sh-channel">{ch.title}</span>
                      {isJoined && (
                        <TbCheck
                          size={24}
                          title={getTranslation("alreadyJoined")}
                          style={{
                            marginLeft: "auto",
                            color: "var(--sh-channel-font-color)",
                          }}
                        />
                      )}
                    </div>
                  );
                })}
              </ul>
            </div>
          )}

          <div className="sh-category">
            {/* DM Search Kısmı */}
            {activeChannel.channelID === "0" && (
              <div
                style={{
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <InputField
                  placeholder={getTranslation("search")}
                  value={dmSearchInputValue}
                  onChange={(e) => setDmSearchInputValue(e.target.value)}
                  style={{
                    height: "38px",
                    width: "150px",
                    paddingLeft: "5px",
                    boxSizing: "border-box",
                  }}
                />

                <ul className="sh-channels-list" style={{ gap: "10px" }}>
                  {(dmSearchInputValue.trim() ? dmSearchResult : myDmList).map(
                    (usr) => {
                      const isSearchMode = dmSearchInputValue.trim();

                      if (
                        !isSearchMode &&
                        !(usr?.ownerDetails && usr?.receiverDetails)
                      ) {
                        return null;
                      }
                      let avatarUrl = "";
                      let userName = "";
                      if (usr.ownerID) {
                        const isOwner = usr.ownerID === userId;
                        avatarUrl = isOwner
                          ? usr.receiverDetails.userAvatar
                          : usr.ownerDetails.userAvatar;
                        userName = isOwner
                          ? usr.receiverDetails.name +
                          " " +
                          usr.receiverDetails.lastname
                          : usr.ownerDetails.name +
                          " " +
                          usr.ownerDetails.lastname;
                      } else {
                        avatarUrl = usr.userAvatar;
                        userName = usr.name + " " + usr.lastname;
                      }

                      return (
                        <div
                          key={usr.id}
                          onClick={() => {
                            setRoomsWithUnread(
                              roomsWithUnreadMessage.filter(
                                (x) => x !== usr.roomID
                              )
                            );
                            if (dmSearchInputValue.trim()) {
                              createDM(usr.id);
                            } else {
                              if (activeRoom.roomID !== usr.roomID) {
                                setActiveRoom(usr);
                              } else {
                                setActiveRoom("");
                              }
                            }
                            onRoomClick();
                          }}
                          className={`sh-search-channel${activeRoom.roomID === usr.roomID &&
                            activeRoom.roomID &&
                            usr.roomID &&
                            (activeView === "chat" || !activeView)
                            ? " sh-search-channel--active"
                            : ""
                            }`}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            width: "160px",
                            gap: "8px",
                            padding: "4px 8px",
                            boxSizing: "border-box",
                            cursor: "var(--pointer)",
                            position: "relative",
                          }}
                          title={usr.name ?? usr.titleDetails?.name}
                        >
                          {avatarUrl ? (
                            <img
                              src={avatarUrl}
                              alt={usr.name ?? usr.titleDetails?.name}
                              width={25}
                              height={25}
                              style={{
                                borderRadius: "50%",
                                minWidth: "25px",
                                minHeight: "25px",
                                objectFit: "cover",
                              }}
                            />
                          ) : (
                            <div
                              style={{
                                minWidth: "25px",
                                minHeight: "25px",
                                borderRadius: "50%",
                                backgroundColor: getAvatarColor(userName),
                                color: "var(--avatar-text-color)",
                                alignItems: "center",
                                justifyContent: "center",
                                display: "flex",
                                fontSize: "12px",
                                fontFamily: "Plus Jakarta Sans",
                              }}
                            >
                              {getFirstAndLastInitials(userName)}
                            </div>
                          )}
                          <span
                            className="sh-channel"
                            style={{ paddingLeft: "0px" }}
                          >
                            {dmSearchInputValue.trim()
                              ? `${usr.name} ${usr.lastname}`
                              : `${usr.titleDetails?.name} ${usr.titleDetails?.lastname}`}
                          </span>
                          {roomsWithUnreadMessage.includes(usr.roomID) && (
                            <span
                              className="light-dot"
                              style={{
                                background: "rgba(229, 147, 42, 1)",
                                height: "7px",
                                width: "7px",
                                borderRadius: "50px",
                                position: "absolute",
                                top: -2,
                                right: -2,
                              }}
                            />
                          )}

                          {!dmSearchInputValue.trim() && (
                            <span
                              title={getTranslation("delete")}
                              onClick={(e) => {
                                e.stopPropagation();
                                setDmToDelete(usr);
                                setIsDeleteDMOpen(true);
                              }}
                              style={{
                                marginLeft: "auto",
                                cursor: "var(--pointer)",
                                color: "var(--sh-channel-hover-font-color)",
                                fontSize: "14px",
                                padding: "0 4px",
                                fontWeight: "bold",
                              }}
                            >
                              <RxCross2 />
                            </span>
                          )}
                        </div>
                      );
                    }
                  )}
                </ul>
              </div>
            )}
          </div>

          {/* Settings Buttonu */}
          {activeChannel.channelID !== "0" &&
            activeChannel.channelID !== "discover" &&(
              <div className="sh-settings" onClick={onSettingsClick}>
                {getTranslation("settings")}{" "}
                <span className="sh-settings-icon" >
                  <TbSettings strokeWidth={3} size={15} />
                </span>
              </div>
            )}
        </div> :
        <div className="sh-channels-panel">
          <span className="sh-channels-title-holder">
            <span>{activeChannel.title}</span>
          </span>
          <div className="sh-channels-panel">
            <SettingsSidebar
              selectedChannel={activeChannel}
              handleChannelChange={setActiveChannel}
              activeMenu={activeSettingsMenu}
              onMenuChange={setActiveSettingsMenu}
            />
          </div>
        </div>
      }


      <AddChatRoomModal
        isOpen={isAddRoomModalOpen}
        onClose={(newRoom = null) => {
          setIsAddRoomModalOpen(false);
          if (newRoom) {
            // rooms güncellenecek
            const token = localStorage.getItem("token");
            Services.SocialHiveGetChannelRooms(
              token,
              activeChannel.channelID
            ).then((res) => {
              if (res.data.status) {
                setOrderedRooms(res.data.result);

                // ➕ Grup eklemesi gerekiyorsa:
                const updatedGroups = roomGroups.map((g) => {
                  if (g.groupID === targetGroupForNewRoom) {
                    return {
                      ...g,
                      roomOrder: [...g.roomOrder, newRoom.roomID], // sonuna ekle
                    };
                  }
                  return g;
                });
                setActiveRoom(newRoom);
                setRoomGroups(updatedGroups);
                updateSettings(updatedGroups); // backend'e yaz
                setTargetGroupForNewRoom(null); // temizle
              }
            });
          }
        }}
        selectedChannel={activeChannel}
      />
      <AddChannelModal
        isOpen={isAddChannelModalOpen}
        onClose={() => setIsAddChannelModalOpen(false)}
      />
      <AddRoomGroupModal
        isOpen={isAddGroupModalOpen}
        onClose={() => setIsAddGroupModalOpen(false)}
        activeChannel={activeChannel}
        onGroupAdded={(newGroup) =>
          setRoomGroups((prev) =>
            Array.isArray(prev) ? [...prev, newGroup] : [newGroup]
          )
        }
      />

      <AlertBox
        title={getTranslation("areYouSure") ?? "Emin misiniz?"}
        message={`${getTranslation("willBeRemoved") ??
          "kişisiyle olan özel mesaj silinecek."
          }`}
        isOpen={isDeleteDMOpen}
        confirmText={getTranslation("yes")}
        cancelText={getTranslation("no")}
        type="warning"
        onCancel={() => {
          setIsDeleteDMOpen(false);
          setDmToDelete(null);
        }}
        onConfirm={() => {
          const token = localStorage.getItem("token");
          Services.SocialHiveRemoveDM(token, dmToDelete.roomID)
            .then((res) => {
              if (res.data.status) {
                getMyDMList();
                if (activeRoom.roomID === dmToDelete.roomID) {
                  setActiveRoom("");
                }
              }
              setIsDeleteDMOpen(false);
              setDmToDelete(null);
            })
            .catch((err) => {
              console.error("DM silme hatası:", err);
              setIsDeleteDMOpen(false);
              setDmToDelete(null);
            });
        }}
      />
    </div>
  );
}
